module.exports = __webpack_public_path__ + "img/xiaoshouzhushou.ed302112.png";